import type { Theme } from '@ringcentral-integration/commons/modules/Theme';

export interface ThemeUIOptions {}
export interface Deps {
  theme: Theme;
}
